import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { createFirestoreInstance } from "redux-firestore";

import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

import * as Sentry from "@sentry/browser";

import store from "./redux/store";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import firebase from "./services/firebase";

Sentry.init({
  dsn: "https://ef462f87997d47cabad752c2373e558a@sentry.io/1874216",
  environment: process.env.REACT_APP_ENV,
});

const rrfProps = {
  firebase,
  config: {
    userProfile: "users",
    useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
  },
  dispatch: store.dispatch,
  createFirestoreInstance, // <- needed if using firestore
};

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: green[600],
    },
  },
  status: {
    danger: "orange",
  },
});

const rootElement = document.getElementById("root");
const rootTree = (
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </ReactReduxFirebaseProvider>
  </Provider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(rootTree, rootElement);
} else {
  ReactDOM.render(rootTree, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
